<template>
  <card-modal :visible="true" :title="title" :disableOk="false" :disablePreview="false">
    <div id="modal-edit-content" class="content" v-bind:class="[showPreview ? 'is-hidden' : '']">

      <p class="control">
        <span class="select mode-select" v-if="isSubslide">
          <select v-model="insertMode">
            <option :value="1">Imagem</option>
            <option :value="2">Video</option>
          </select>
        </span>

        <span class="select">
          <select v-model="editLanguage">
            <option v-for="language of languageList" 
                    :value="language.slug"
            >{{language.name}}</option>
          </select>
        </span>
      </p>

      <!-- <p class="control">
        <span class="select">
          <select v-model="editLanguage">
            <option v-for="language of languageList" 
                    :value="language.slug"
            >{{language.name}}</option>
          </select>
        </span>
      </p> -->

      <div v-for="language of languageList"
           v-show="language.slug === editLanguage"
           class="localization columns"
      >
        <div class="column column-quill is-12">
          <p class="control">
            <label class="label">{{'Descrição ['+ language.name +']'}}</label>
            <quill :ref="'q1' + language.slug" :options="quillOptions"></quill>
          </p>

          <p class="control" v-if="showPlusDetail">
            <label class="label">{{'Mais Detalhes ['+ language.name +']'}}</label>
            <quill :ref="'q2' + language.slug" :options="quillOptions"></quill>
          </p>
        </div>
      </div>

      <div class="columns" v-show="!isSubslide || (isSubslide && insertMode === 1)">
        <div class="column is-half">
          <label class="label">Foreground 1 <span class="font-weight-light">{{foreground1Text}}</span></label>
          <figure v-if="!newForeground1 && slide.foreground_image_1" class="image is-16by9 slide-image fake-dropzone">
            <img :src="slide.foreground_image_1">
            <a class="dz-remove" @click="showDropzone('foreground1')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="slideForeground1"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl + '&type=' + foreground1Type"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadForeground1"
                      v-on:vdropzone-removedfile="removeForeground1"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
        <div class="column is-half" v-show="!isSubslide || (isSubslide && insertMode === 1)">
          <label class="label">Foreground 2 <span class="font-weight-light">{{foreground2Text}}</span></label>
          <figure v-if="!newForeground2 && slide.foreground_image_2" class="image  slide-image fake-dropzone">
            <img :src="slide.foreground_image_2">
            <a class="dz-remove" @click="showDropzone('foreground2')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="slideForeground2"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl + '&type=' + foreground2Type"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadForeground2"
                      v-on:vdropzone-removedfile="removeForeground2"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
      </div>

      <div class="columns" v-show="isSubslide && insertMode === 2">
        <div class="column is-12">
          <label class="label">Foreground 1</label>
          <figure v-if="!newForegroundVideo && slide.foreground_image_1" class="image fake-dropzone-video">
            <video width="100%" height="100%" controls>
              <source :src="slide.foreground_image_1" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <a class="dz-remove" @click="showDropzone('foreground1')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="slideForegroundVideo"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl + '&type=5'"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadForeground1"
                      v-on:vdropzone-removedfile="removeForeground1"
                      acceptedFileTypes=".mp4"
            ></dropzone>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <label class="label">Posição</label>
          <div class="select is-fullwidth">
            <select v-model="slide.order">
              <option v-for="order of orderOptions" :value="order.id">{{order.value}}</option>
            </select>
          </div>
        </div>
      </div>

    </div>

    <div id="modal-preview-content" class="content" v-if="previewReady" v-bind:class="[showPreview ? '' : 'is-hidden']">
      <div class="control is-grouped">
        <p class="control">
          <span class="select">
            <select v-model="previewLanguage">
              <option v-for="language of languageList" 
                      :value="language.slug"
              >{{language.name}}</option>
            </select>
          </span>
        </p>
        <p class="control" v-show="currentDetail">
          <a class="button is-primary" 
             @click="showDetail = !showDetail"
             :class="{ 'is-outlined' : showDetail }"
          >
            Detalhes
          </a>
        </p>
      </div>

      <parallax-composite :background1="menuBackground1 ? 'url(' + menuBackground1 + ')' : null"
                          :background2="menuBackground2 ? 'url(' + menuBackground2 + ')' : null"
                          :foreground1="slide.foreground_image_1 ? 'url(' + slide.foreground_image_1 + ')' : null"
                          :foreground2="slide.foreground_image_2 ? 'url(' + slide.foreground_image_2 + ')' : null"
                          :insertMode="insertMode"
                          :backgroundColor="menu.background_color"
                          :textboxColor="menu.textbox_color"
                          :textColor="menu.text_color"
                          :description="currentDescription"
                          :plusDetail="currentDetail"
                          :showDetail="showDetail"
                          :slide="slide.order - 1"
                          :category="slide.slide_category_id"
                          :editWidth="previewImageWidth"
      ></parallax-composite>

      <div class="preview-text-box"
           v-bind:style="{background: this.menu.textbox_color}"
      >
        <div class="preview-description"></div>
      </div>

      <div class="preview-slide-name-warning">
        <span class="preview-warning-text"><b>Aviso:</b> {{ previewWarning }}</span>
      </div>
    </div>
  </card-modal>
</template>

<script>
import CardModal from '../Util/CardModal'
import Dropzone from '../Util/DropzoneForm'
import Quill from 'vue-bulma-quill'
import ParallaxComposite from '../Util/ParallaxComposite'
import { API_ROOT, BACKGROUND_IMG_PATH, SLIDE_IMG_PATH, LANGUAGE_LIST, CONTENT_STATES, MENUS } from '../../config'

const DESKTOP_MIN_WIDTH = 769
const MAX_PREVIEW_SIZE_MOBILE = 671
const DEFAULT_PREVIEW_SIZE = 600

export default {
  components: {
    CardModal,
    Quill,
    Dropzone,
    ParallaxComposite
  },

  props: {
    title: String,
    slideTotal: Number,
    slideData: Object,
    parent: Number,
    menu: Object,
    isSubslide: Boolean
  },

  data () {
    return {
      languageList: LANGUAGE_LIST,
      editLanguage: 'pt',
      insertMode: 1,
      defaultMode: null,
      defaultModePath: null,
      states: CONTENT_STATES,
      showPreview: false,
      previewLanguage: 'pt',
      previewText: null,
      previewImageWidth: null,
      previewReady: false,
      previewWarning: 'Esta pré-visualização pode não ser uma representação fiel dos quiosques.',
      slide: {
        coach_id: window.store.state.route.params.id,
        slide_category_id: parseInt(window.store.state.route.params.cat),
        pt: {
          description: null,
          plus_detail: null
        },
        en: {
          description: null,
          plus_detail: null
        },
        es: {
          description: null,
          plus_detail: null
        },
        fr: {
          description: null,
          plus_detail: null
        },
        foreground_image_1: null,
        foreground_image_2: null,
        foreground_path_1: null,
        foreground_path_2: null,
        state_id: 1,
        order: this.slideTotal + 1,
        parent_id: this.parent
      },
      newForeground1: false,
      newForeground2: false,
      newForegroundVideo: false,
      quillOptions: {
        theme: 'snow',
        formats: ['italic', 'script'],
        modules: {
          toolbar: [
            ['italic'],
            [{ 'script': 'super' }]
          ]
        }
      },
      editors: null,
      currentDescription: null,
      currentDetail: null,
      showDetail: false,
      submitIsActive: true,
      previewIsActive: true
    }
  },

  beforeDestroy () {
    let trash = document.body.querySelectorAll('.dz-hidden-input')
    for (let t of trash) {
      t.remove()
    }
  },

  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.handleResize)
    })

    setTimeout(() => {
      this.handleResize()
      this.previewReady = true
    }, 10)

    // get quill editors
    this.editors = {
      pt: {
        q1: this.$refs.q1pt[0].editor,
        q2: this.$refs.q2pt ? this.$refs.q2pt[0].editor : null
      },
      en: {
        q1: this.$refs.q1en[0].editor,
        q2: this.$refs.q2en ? this.$refs.q2en[0].editor : null
      },
      es: {
        q1: this.$refs.q1es[0].editor,
        q2: this.$refs.q2es ? this.$refs.q2es[0].editor : null
      },
      fr: {
        q1: this.$refs.q1fr[0].editor,
        q2: this.$refs.q2fr ? this.$refs.q2fr[0].editor : null
      }
    }

    if (this.slideData) {
      this.slide.state_id = this.slideData.state_id
      this.slide.order = parseInt(this.slideData.order)

      for (let language of this.slideData.languages) {
        if (language.pivot.description) {
          this.editors[language.slug].q1.setContents(language.pivot.description, 'api')
        }
        if (language.pivot.plus_detail && this.showPlusDetail) {
          this.editors[language.slug].q2.setContents(language.pivot.plus_detail, 'api')
        }
      }

      this.updateCurrentText('pt')

      this.slide.foreground_image_1 = this.slideData.foreground_path_1 ? SLIDE_IMG_PATH + this.slideData.foreground_path_1 : null
      this.slide.foreground_path_1 = this.slideData.foreground_path_1
      this.slide.foreground_image_2 = this.slideData.foreground_path_2 ? SLIDE_IMG_PATH + this.slideData.foreground_path_2 : null
      this.slide.foreground_path_2 = this.slideData.foreground_path_2

      this.newForeground1 = this.slideData.foreground_path_1 === null
      this.newForeground2 = this.slideData.foreground_path_2 === null

      this.insertMode = this.isVideo(this.slideData.foreground_path_1) ? 2 : 1
      this.defaultMode = this.insertMode
      this.defaultModePath = this.slideData.foreground_path_1
    }
  },

  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    },

    userToken () {
      return window.store.state.auth.token
    },

    dropzoneUploadUrl () {
      return API_ROOT + 'resource/slide/upload?token=' + this.userToken
    },

    textZoom () {
      return 'scale(' + this.previewImageWidth / DEFAULT_PREVIEW_SIZE + ')'
    },

    orderOptions () {
      let object = []
      let target = this.slideTotal
      if (!this.slideData) {
        target += 1
      }
      for (let i = 1; i <= target; i++) {
        object.push({id: i, value: i})
      }
      return object
    },

    menuBackground1 () {
      if (this.menu.background_path_1) {
        return BACKGROUND_IMG_PATH + this.menu.background_path_1
      }
      return null
    },

    menuBackground2 () {
      if (this.menu.background_path_2) {
        return BACKGROUND_IMG_PATH + this.menu.background_path_2
      }
      return null
    },

    showPlusDetail () {
      if (this.slide.slide_category_id === MENUS.ambepoca || this.slide.slide_category_id === MENUS.eraumavez) {
        return false
      }
      return true
    },

    foreground1Type () {
      if (this.parent) {
        return 3
      } else {
        return 1
      }
    },

    foreground2Type () {
      if (this.parent) {
        return 4
      } else {
        return 2
      }
    },

    foreground1Text () {
      return this.isSubslide ? '(1848x1008px)' : '(1920x1080px)'
    },

    foreground2Text () {
      return this.isSubslide ? '(2772x1008px)' : '(2880x1080px)'
    }
  },

  methods: {
    successUploadForeground1 (file) {
      this.slide.foreground_image_1 = SLIDE_IMG_PATH + JSON.parse(file.xhr.response).file
      this.slide.foreground_path_1 = JSON.parse(file.xhr.response).file

      this.newForeground1 = false
      this.newForegroundVideo = false
    },

    removeForeground1 () {
      console.log('A file was been removed')
      this.slide.foreground_image_1 = null
      this.slide.foreground_path_1 = null
    },

    successUploadForeground2 (file) {
      this.slide.foreground_image_2 = SLIDE_IMG_PATH + JSON.parse(file.xhr.response).file
      this.slide.foreground_path_2 = JSON.parse(file.xhr.response).file

      this.newForeground2 = false
    },

    removeForeground2 () {
      console.log('A file was been removed')
      this.slide.foreground_image_2 = null
      this.slide.foreground_path_2 = null
    },

    isSelectedLanguage (slug) {
      return slug === this.previewLanguage
    },

    handleResize () {
      let element = document.getElementById('modal-edit-content')
      if (element) {
        this.previewImageWidth = element.getBoundingClientRect().width
      }
    },

    showDropzone (selector) {
      if (selector === 'foreground1') {
        this.newForeground1 = true
        this.newForegroundVideo = true
        this.removeForeground1()
      }

      if (selector === 'foreground2') {
        this.newForeground2 = true
        this.removeForeground2()
      }
    },

    deltaToHtml (delta) {
      let html = ''
      for (let section of delta.ops) {
        if (section.attributes) {
          if (section.attributes.bold) {
            html += '<b>'
          }
          if (section.attributes.italic) {
            html += '<i>'
          }
          if (section.attributes.script && section.attributes.script === 'super') {
            html += '<sup>'
          }

          html += section.insert.replace(/\n/g, '<br/>')

          if (section.attributes.bold) {
            html += '</b>'
          }
          if (section.attributes.italic) {
            html += '</i>'
          }
          if (section.attributes.script && section.attributes.script === 'super') {
            html += '</sup>'
          }
        } else {
          html += section.insert.replace(/\n/g, '<br/>')
        }
      }
      return html
    },

    updateCurrentText (lang) {
      let delta1 = this.deltaToHtml(this.editors[lang].q1.editor.delta)
      this.currentDescription = delta1 === '<br/>' ? null : delta1
      if (this.editors[lang].q2) {
        let delta2 = this.deltaToHtml(this.editors[lang].q2.editor.delta)
        this.currentDetail = delta2 === '<br/>' ? null : delta2
      }
    },

    isVideo (path) {
      let videoExtensions = ['mp4', 'mov', 'mkv', 'avi']

      let splitPath = path.split('.')
      let extension = splitPath.pop()

      if (videoExtensions.includes(extension)) {
        return true
      }
      return false
    }
  },

  watch: {
    currentEvent: function (val) {
      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        this.slide.pt.description = this.editors.pt.q1.getContents()
        this.slide.en.description = this.editors.en.q1.getContents()
        this.slide.es.description = this.editors.es.q1.getContents()
        this.slide.fr.description = this.editors.fr.q1.getContents()

        if (this.showPlusDetail) {
          this.slide.pt.plus_detail = this.editors.pt.q2.getContents()
          this.slide.en.plus_detail = this.editors.en.q2.getContents()
          this.slide.es.plus_detail = this.editors.es.q2.getContents()
          this.slide.fr.plus_detail = this.editors.fr.q2.getContents()
        }

        if (this.slideData) {
          window.store.dispatch('updateSlide', { id: this.slideData.id, slide: this.slide })
        } else {
          window.store.dispatch('saveSlide', this.slide)
        }
      }
      if (val === 'modal-card-preview') {
        this.updateCurrentText(this.previewLanguage)
        this.showPreview = !this.showPreview
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    },

    showPreview: function (val) {
      if (val && window.innerWidth < DESKTOP_MIN_WIDTH) {
        this.previewImageWidth = MAX_PREVIEW_SIZE_MOBILE - ((DESKTOP_MIN_WIDTH - 1) - window.innerWidth)
      }
    },

    submitIsActive: function (val) {
      if (val) {
        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled')
      }
    },

    previewIsActive: function (val) {
      if (val) {
        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled')
      }
    },

    previewLanguage: function (val) {
      this.updateCurrentText(val)
    },

    insertMode: function (oldval, val) {
      if (oldval !== val) {
        if (val !== this.defaultMode && this.defaultModePath) {
          this.slide.foreground_image_1 = SLIDE_IMG_PATH + this.defaultModePath
          this.slide.foreground_path_1 = this.defaultModePath

          this.newForeground1 = false
          this.newForegroundVideo = false
        } else {
          this.removeForeground1()
        }

        /*
        if (val === 2) {
          this.previewIsActive = true
        } else {
          this.previewIsActive = false
        }
        */
      }
    }
  }
}
</script>

<style lang="styl">
  @import '~quill/assets/snow';
</style>

<style>
  @import url('~dropzone/dist/dropzone.css');
  @import 'https://fonts.googleapis.com/css?family=Roboto';

  .is-hidden {
    display: none !important;
  }

  .column-quill {
    height: 100%
  }

  .ql-editor p:not(:last-child) {
    margin-bottom: 0 !important;
  }

  #slideForeground1,
  #slideForeground2,
  #slideForegroundVideo {
    height: 165px;
    display: flex;
  }

  #slideForeground1.dropzone .dz-preview .dz-error-message,
  #slideForeground2.dropzone .dz-preview .dz-error-message,
  #slideForegroundVideo.dropzone .dz-preview .dz-error-message {
    top: 90px;
    left: 73px;
  }

  #slideForeground1.dropzone .dz-message,
  #slideForeground2.dropzone .dz-message,
  #slideForegroundVideo.dropzone .dz-message {
    margin: 4em auto;
  }

  .content #slideForeground1 a:not(.button):hover,
  .content #slideForeground2 a:not(.button):hover,
  .content #slideForegroundVideo a:not(.button):hover {
    border-bottom-color: inherit;
  }

  .fake-dropzone {
    border: 1px solid #dbdbdb;
    border-radius: 3px;
  }

  .fake-dropzone .dz-remove {
    font-family: 'Roboto', sans-serif;
    color: #777;
    position: absolute;
    z-index: 30;
    color: white;
    margin-left: 15px;
    padding: 10px;
    top: inherit;
    bottom: 15px;
    border: 2px white solid;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
    text-align: center;
    display: block;
    cursor: pointer;
    background-color: rgba(37, 148, 139, 0.8);
  }

  .fake-dropzone:hover .dz-remove {
    opacity: 1;
  }

  .fake-dropzone a:not(.button) {
    border-bottom: 2px white solid !important;
  }

  .fake-dropzone a:not(.button):hover, .content #slideForeground2 a:not(.button):hover {
    border-bottom-color: inherit !important;
  }

  .fa-slide-preview {
    font-size: 2.5em !important;
  }

  .fa-slide-preview .fa-circle {
    color: black !important;
  }

  .preview-slide-name {
    font-family: 'RongelExpert';
    font-size: 15.2pt;
    letter-spacing: 2px;
    position: absolute;
    top: 136px;
    left: 32px;
    transform-origin: 0% 0%;
    width: 100%;
  }

  .preview-slide-name-warning {
    margin-top: 2px;
    transform-origin: 0% 0%;
  }

  .preview-warning-text {
    vertical-align: middle;
  }

  .mode-select {
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// SlideEditModal.vue?5ea4eff0